import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, UncontrolledTooltip, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './black-list.reducer';
import { IBlackList } from 'app/shared/model/black-list.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBlackListDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export class BlackListDetail extends React.Component<IBlackListDetailProps> {
  // 初始化
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }
  // 渲染
  render() {
    const { blackListEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="lehomeApp.blackList.detail.title">BlackList</Translate> [<b>{blackListEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="description">
                <Translate contentKey="lehomeApp.blackList.description">Description</Translate>
              </span>
              <UncontrolledTooltip target="description">
                <Translate contentKey="lehomeApp.blackList.help.description" />
              </UncontrolledTooltip>
            </dt>
            <dd>{blackListEntity.description}</dd>
            <dt>
              <span id="createdBy">
                <Translate contentKey="lehomeApp.blackList.createdBy">Created By</Translate>
              </span>
            </dt>
            <dd>{blackListEntity.createdBy}</dd>
            <dt>
              <span id="createdAt">
                <Translate contentKey="lehomeApp.blackList.createdAt">Created At</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={blackListEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <Translate contentKey="lehomeApp.blackList.user">User</Translate>
            </dt>
            <dd>{blackListEntity.userId ? blackListEntity.userId : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/black-list" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
          &nbsp;
          <Button tag={Link} to={`/entity/black-list/${blackListEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ blackList }: IRootState) => ({
  blackListEntity: blackList.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlackListDetail);
